import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ModalWindow from '../commons/helpers/modalWindow'; 
import Toast from '../commons/helpers/toast'; 
import {format as stringFormat} from 'react-string-format';

import {quoteQuickUpdateAction} from '../../actions/eventActions';  
import {otherExpListAction} from '../../actions/settings/otherExpActions';
// import { clientProfileRateCardListAction } from '../../actions/clientActions'; 
import { aflt_skillListAction } from '../../actions/settings/affiliates/aflt_skillActions';
import {eventGetCrewChiefCountAction,shiftGetDetailsAction} from '../../actions/eventActions';
import {aflt_departmentsListAction} from '../../actions/settings/affiliates/aflt_departmentActions';

import {OTHER_EXP_LIST_SUCCESS,CLIENT_RATE_CARD_LIST_SUCCESS, CLIENT_RATE_CARD_LIST_ERROR, SHIFT_QUICK_UPDATE_SUCCESS, SHIFT_GET_DETAILS_SUCCESS, SHIFT_GET_DETAILS_ERROR, SHIFT_QUICK_UPDATE_ERROR, SKILL_LIST_AFFILIATE_SUCCESS,SKILL_LIST_AFFILIATE_ERROR} from '../../actions';  

import {MSG_REQUIRED, MSG_SHIFT_QUICK_UPDATE_SUCCESS, MSG_SHIFT_QUICK_UPDATE_ERROR, MSG_COMMON_FORM_ERROR, MSG_SERVER_DATA_FETCH_ERROR, MSG_CHIEF_COUNT_LESS, MSG_SHIFT_SKILL_REMOVE_ERROR, MSG_SHIFT_SKILL_EDIT_ERROR, MSG_SKILL_ZERO_ERROR } from '../../configs/msgConfigs'; 
import {LBL_SKILL,LBL_OTHER_EXPENSES,LBL_CHARGE_RATE, LBL_CHIEFS, LBL_ADD, LBL_HOURS, LBL_DEPARTMENT, LBL_SELECT, LBL_DEPARTMENT_ALL_SHIFTS,LBL_CONFIRM_DELETE} from '../../configs/labelConfigs';  
import {DELETE_SYMBOL, LOGIN_CLIENT_GROUP, LOGIN_AFFILIATE_GROUP} from '../../configs/staticConfigs';  

import {checkNum,checkNumDotZero} from '../../utils/validation'; 
import {convertDecimalToHHMM} from '../../utils/commonUtilities';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';

let msgChiefCountLess = '';

class ShiftSkillsQuickEdit extends Component {
    constructor(props){
        super()
        this.state = { 
            quoteShiftId:0,   
            otherExpensesMasterList: [], 
            shift_skills: [],
            shift_expenses: [], 
            shiftSkillAllDetails: {},
            shiftSkillOthExpEditDataRows: [], // {rowNum:1,rowType:'skill/exp',rowActive:'yes', skillData.../ExpData...} 
            totalDataRows: 0,
            totalAmount: 0,
            deleteRowIndexNum: 0, 
            deleteRowName: '', 
            skillRatesAllData: [],             
            showModal: false,
            errMsgCommon: '',
            numCrewChiefs: 0,
            numCrewChiefsErr: '',
            crew_chief_bonus:0, 
            totalSkillRowsServer: 0,
            isSaveBtnEnable:true,// for disable save button during edit until any change occur
            department: 0,
            applyDeptShifts: false,
            deptCheckDisable: true
        }

        this.handleOpenModal  = this.handleOpenModal.bind(this);
        this.handleModelClose = this.handleModelClose.bind(this);
        this.validateQuickAdd = this.validateQuickAdd.bind(this); 
        this.modalDelete = React.createRef(); 

    }

    reloadQuoteDetails = () =>{
        this.props.reloadDetails(this.props.quoteShiftId);
    }

    handleOpenModal = () => {
        this.setState({
          showModal:true
        });
    } 
    
    handleModelClose = () =>{
        this.setState({
            showModal:false
        }, () => {
            this.props.resetModalForm();
        });
    }   

    onHandleChangeTot = (e) => { 
        let msgStr = ''; 
        if(!checkNum(e.target.value.trim()) || e.target.value.trim()==='') msgStr = MSG_REQUIRED; 
        this.setState({numCrewChiefs:e.target.value, numCrewChiefsErr:msgStr}); 
    }

    onHandleChange = (rowNum,fldType,currValue,e) => {
        let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
        let msgStr = ''; 
        let errMsgCommon = '';  
        if(fldType==='sel_skill') {
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).skillId = e.target.value; 
            if(parseInt(e.target.value,10)===0) {
                msgStr = MSG_REQUIRED; 
                shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).charge_rate_total = 0; 
            }
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).skillId_err = msgStr; 
            this.updateUsedRow('skill',currValue,e.target.value,rowNum); 
        }
        else if(fldType==='txt_qty') { 
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).count = e.target.value; 
            if(!checkNumDotZero(e.target.value.trim()) || parseInt(e.target.value.trim(),10)===0 || e.target.value.trim()==='') { 
                msgStr = MSG_REQUIRED; 
            }
            else {
                let chiefCount=parseInt(shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).chiefs_required,10);
                if(chiefCount > parseInt(e.target.value.trim(),10)) msgStr = msgChiefCountLess; 
            }
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).chiefs_required_err = msgStr; 
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).count_err = msgStr; 
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).charge_rate_total_err = ''; 
        } 
        else if(fldType==='txt_qty_chiefs') {
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).chiefs_required = e.target.value; 
            if(!checkNumDotZero(e.target.value.trim()) || e.target.value.trim()==='') {
                msgStr = MSG_REQUIRED; 
            }
            else {
                let countVal = parseInt(shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).count,10); 
                if(countVal < parseInt(e.target.value.trim(),10)) msgStr = msgChiefCountLess; 
            }
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).count_err = msgStr; 
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).chiefs_required_err = msgStr; 
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).charge_rate_total_err = ''; 
        }
        else if(fldType==='txt_hrs') {
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).hour = e.target.value; 
            if(!checkNumDotZero(e.target.value.trim()) || parseInt(e.target.value.trim(),10)===0 || e.target.value.trim()==='') msgStr = MSG_REQUIRED;
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).hour_err = msgStr; 
        }
        else if(fldType==='txt_rate') {
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).charge_rate_total = e.target.value; 
            if(!checkNumDotZero(e.target.value.trim()) || parseInt(e.target.value.trim(),10)===0 || e.target.value.trim()==='') msgStr = MSG_REQUIRED;
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).charge_rate_total_err = msgStr; 
        }
        else if(fldType==='sel_exp') {
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).expId = e.target.value; 
            if(parseInt(e.target.value.trim(),10)===0) msgStr = MSG_REQUIRED;
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).expId_err = msgStr; 
            this.updateUsedRow('exp',currValue,e.target.value,rowNum); 
        }
        else if(fldType==='txt_exp_rate') { 
            shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).cost = e.target.value; 
            if(!checkNumDotZero(e.target.value.trim()) || parseInt(e.target.value.trim(),10)===0 || e.target.value.trim()==='') msgStr = MSG_REQUIRED; shiftSkillOthExpEditDataRows.find(rObj => rObj.rowNum===rowNum).cost_err = msgStr; 
        } 
        this.setState({shiftSkillOthExpEditDataRows,errMsgCommon,isSaveBtnEnable:true}, () => this.loadRate(rowNum,fldType));  
    }

    onHandleDeptChange = (e) =>{
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const {name}  = e.target;
        if(name === 'applyDeptShifts')
            this.setState({applyDeptShifts: value, isSaveBtnEnable: true});
        else{
            let deptTemp = this.state.applyDeptShifts;
            let disableCheck = false;
            if(value === ''){
                deptTemp = false;
                disableCheck = true;
            }
            this.setState({department: value, isSaveBtnEnable: true, applyDeptShifts: deptTemp, deptCheckDisable: disableCheck});
        }
        console.log(name, value);
    }

    loadRate = (rowNum,fldType) => { 
        let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
        let skillRatesAllData = this.state.skillRatesAllData; 
        let tmpObj = shiftSkillOthExpEditDataRows.filter(rowItem => rowItem.rowNum===rowNum); 
        let rowObj = tmpObj[0]; 
        let crew_chief_bonus = Number(this.state.crew_chief_bonus); 

        if(rowObj.rowType==='skill') {
            let chargeRate = 0; 
            // let hourValue  = 0; 
            let isFinal    = false; 

            if(parseInt(rowObj.skillId,10) > 0 && checkNumDotZero(rowObj.count) && parseFloat(rowObj.count) >= 0 && checkNumDotZero(rowObj.hour) && parseFloat(rowObj.hour) >= 0 && checkNumDotZero(rowObj.chiefs_required) ) { 
                let rateObjArr = [];
                // IF THIS SKILL WAS ALREADY THERE, TAKE THE RATE FROM shiftDataDetails ELSE TAKE IT FROM skillRatesAllData
                let shift_skills = this.state.shiftSkillAllDetails.shift_skills;
                rateObjArr = shift_skills.filter(rateItem => parseInt(rateItem.skill.id,10)===parseInt(rowObj.skillId,10));
                if(rateObjArr.length) {
                    let rateObj = rateObjArr[0];             
                    rowObj.charge_rate_total = (
                        ((parseFloat(rateObj.charge_rate_total)/parseFloat(rateObj.count))*parseFloat(rowObj.count))+(parseFloat(rowObj.chiefs_required)*crew_chief_bonus)*parseFloat(rowObj.hour)).toFixed(2); 
                }
                else { 
                    let rateHourTaken = 1; 
                    rateObjArr = skillRatesAllData.filter(rateItem => parseInt(rateItem.skill_id,10)===parseInt(rowObj.skillId,10));
                    if(rateObjArr.length) {
                        let rateObj = rateObjArr[0]; 
                        let rowCnt  = 0; 
                        let rateTaken = 0; 
                        if(rateObj.rates_data.length) {
                            rateObj.rates_data.forEach(hourRateItem => {

                                // if(rowCnt===0 && parseFloat(rowObj.hour) < 1) {
                                //     rowCnt++; 
                                //     chargeRate = parseFloat(hourRateItem.charge_rate); 
                                //     isFinal    = hourRateItem.is_final; 
                                // }
                                // else if(parseFloat(rowObj.hour) >= parseFloat(hourRateItem.hours)) {
                                //     chargeRate = parseFloat(hourRateItem.charge_rate); 
                                //     isFinal    = hourRateItem.is_final; 
                                // }
                                if(rateTaken===0) {
                                    rowCnt++; 
                                    chargeRate = parseFloat(hourRateItem.charge_rate); 
                                    isFinal    = hourRateItem.is_final; 
                                    rateHourTaken = hourRateItem.hours; 
                                }
                                
                                if(parseFloat(hourRateItem.hours) >= parseFloat(rowObj.hour)) {
                                    rateTaken = 1; 
                                }

                            })
                        }
                    }

                    if(rateHourTaken > 1 && !isFinal) chargeRate = (chargeRate/parseInt(rateHourTaken,10)).toFixed(2); 
                    rowObj.charge_rate_total = (((chargeRate*parseFloat(rowObj.hour))*parseFloat(rowObj.count))+(parseFloat(rowObj.chiefs_required)*crew_chief_bonus*parseFloat(rowObj.hour))).toFixed(2); 

                    // let dec = parseFloat(rowObj.hour).toFixed(2)-parseInt(rowObj.hour,10); 
                    // if(isFinal) rowObj.charge_rate_total = (((chargeRate*parseFloat(rowObj.hour))*parseFloat(rowObj.count))+(parseFloat(rowObj.chiefs_required)*crew_chief_bonus*parseFloat(rowObj.hour))).toFixed(2); 
                    // else {
                    //     chargeRate = (chargeRate/parseInt(rateHourTaken,10)).toFixed(2); 
                    //     if(dec > 0)  chargeRate = parseFloat(chargeRate+(chargeRate*dec)).toFixed(2); 
                    //     rowObj.charge_rate_total = ((chargeRate*parseFloat(rowObj.count))+(parseFloat(rowObj.chiefs_required)*crew_chief_bonus*parseFloat(rowObj.hour))).toFixed(2);
                    // }
                }
                
                // IF IS FINAL IS TRUE THEN IT IS HOURLY RATE 
                let index = shiftSkillOthExpEditDataRows.findIndex(rowItem => rowItem.rowNum===rowNum)
                // Replace the item by index.
                shiftSkillOthExpEditDataRows.splice(index, 1, rowObj); 
                this.setState({shiftSkillOthExpEditDataRows});    
            }
        }
        let totalAmount = this.calcTotal(); 
        if(fldType==='txt_exp_rate') {
            this.setState({totalAmount:totalAmount,numCrewChiefsErr:''});  
        }
        else if(fldType!=='txt_exp_rate') { 
            //let numCrewChiefs = 0; // this.calcNumCrewChiefs();  
            this.setState({totalAmount:totalAmount,numCrewChiefsErr:''}); // numCrewChiefs:numCrewChiefs, 
        }
    }

    calcNumCrewChiefs = () => {
        let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
        let numCrewChiefs = 0; 
        let totalQty = 0; 
        let crewChiefCount = parseInt(this.props.crewChiefCount,10); 
        if(crewChiefCount > 0) {
            shiftSkillOthExpEditDataRows.forEach(rowItem => {
                if(rowItem.rowActive==='yes' && rowItem.rowType==='skill' && rowItem.charge_rate_total_err==='') totalQty += parseFloat(rowItem.count); 
            })   
            numCrewChiefs = parseInt((totalQty/crewChiefCount),10); 
        }
        return(numCrewChiefs); 
    }

    calcTotal = () => {
        let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
        let totalAmount = 0; 
        shiftSkillOthExpEditDataRows.forEach(rowItem => {
            if(rowItem.rowActive==='yes' && rowItem.rowType==='skill' && rowItem.charge_rate_total_err==='') totalAmount += parseFloat(rowItem.charge_rate_total); 
            else if(rowItem.rowActive==='yes' && rowItem.rowType==='exp' && rowItem.cost_err==='') totalAmount += parseFloat(rowItem.cost);  
        })   
        return(totalAmount.toFixed(2)); 
    }

    deleteBtnClick = (rowNum) =>{
        let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
        let tmpObj = shiftSkillOthExpEditDataRows.filter(rowItem => rowItem.rowNum===rowNum); 
        let filterObj = tmpObj[0]; 
        let deleteRowName = ''; 
        if(filterObj.rowType==='skill') {
            this.setState({deleteRowIndexNum: rowNum, deleteRowName:deleteRowName,isSaveBtnEnable:true}, () => this.removeRow(this.state.deleteRowIndexNum));            
        }
        else if(filterObj.rowType==='exp') {
            this.setState({deleteRowIndexNum: rowNum, deleteRowName:deleteRowName,isSaveBtnEnable:true}, () => this.removeRow(this.state.deleteRowIndexNum));         
        }
    }

    onDeleteAction = () =>{
        if(this.state.deleteRowIndexNum > 0) this.removeRow(this.state.deleteRowIndexNum);
        this.modalDelete.current.handleModelClose();              
    }

    onModalFormReset = () =>{ 
        this.setState({deleteRowIndexNum:0, deleteRowName:''}); 
    }

    insertNewRow = (rowType) =>{
        if(rowType==='skill') {
            let totalDataRows = this.state.totalDataRows; 
            let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
            let shiftLength = convertDecimalToHHMM(this.props.shiftLengthHrs);
            totalDataRows++;
            shiftSkillOthExpEditDataRows.push({rowNum:totalDataRows, rowType:'skill', rowActive:'yes', shiftSkillId:0, skillId:0, skill_name:'', count:0, chiefs_required:0, base_pay_rate:0, charge_rate:0, charge_rate_total:0, hour:this.props.shiftLengthHrs, shiftLength:shiftLength, skillId_err:'', count_err:'', chiefs_required_err:'',  hour_err:'', charge_rate_total_err:''});     
            this.setState({shiftSkillOthExpEditDataRows:shiftSkillOthExpEditDataRows,totalDataRows:totalDataRows,errMsgCommon:''});
        }
        else if(rowType==='exp') {
            let totalDataRows = this.state.totalDataRows; 
            let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
            totalDataRows++;
            shiftSkillOthExpEditDataRows.push({rowNum:totalDataRows, rowType:'exp', rowActive:'yes', shiftExpId:0, expId:0, name:'', cost:0, expId_err:'', cost_err:''});
            this.setState({shiftSkillOthExpEditDataRows:shiftSkillOthExpEditDataRows,totalDataRows:totalDataRows,errMsgCommon:''});  
        }
    }

    removeRow = (rowNum) =>{
        let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
        let remRow = shiftSkillOthExpEditDataRows.filter(rowItem => rowItem.rowNum===rowNum); 
        let currDataArr = this.state.shiftSkillAllDetails; 
        if(Array.isArray(remRow) && remRow[0]) {
            let remSkillId = remRow[0].skillId;
            let currDataSkills = currDataArr.shift_skills; 
            let newSkillData = currDataSkills.filter(skillItem => skillItem.skill.id!==remSkillId);
            currDataArr.shift_skills = newSkillData; 
        }

        let newObjArr = shiftSkillOthExpEditDataRows.filter(rowItem => rowItem.rowNum!==rowNum);
        // let totalAmount = this.calcTotal(); 
        this.updateUsedRow ('removeRow',0,0,rowNum); 
        this.setState({shiftSkillOthExpEditDataRows:newObjArr,shiftSkillAllDetails:currDataArr}, () => {
            let totalAmount = this.calcTotal(); 
            this.setState({totalAmount:totalAmount}); 
        }); 
    }    

    validateQuickAdd = () => {
        let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
        let foundIssue = 0; 
        let foundCountIssue = 0; 
        let numSkillRows = 0; 
        let arrSelSkilIds = []; 
        shiftSkillOthExpEditDataRows.forEach(rowItem => {
            if(rowItem.rowActive==='yes' && rowItem.rowType==='skill') { 
                if(!arrSelSkilIds.includes(rowItem.skillId)) {
                    arrSelSkilIds.push(rowItem.skillId); 
                }
                else {
                    foundIssue = 1; rowItem.skillId_err = MSG_REQUIRED;
                }
                if(Number(rowItem.skillId)===0) { foundIssue = 1; rowItem.skillId_err = MSG_REQUIRED; }
                if(!checkNumDotZero(rowItem.count) || parseFloat(rowItem.count)<=0) { foundIssue = 1; rowItem.count_err = MSG_REQUIRED; }
                if(!checkNumDotZero(rowItem.chiefs_required)) { foundIssue = 1; rowItem.chiefs_required_err = MSG_REQUIRED; }
                if(checkNumDotZero(rowItem.count) && checkNumDotZero(rowItem.chiefs_required) && parseInt(rowItem.count,10) < parseInt(rowItem.chiefs_required,10)) { foundIssue = 1; foundCountIssue = 3; rowItem.chiefs_required_err = msgChiefCountLess; }  
                if(parseFloat(rowItem.hour)<=0) { foundIssue = 1; rowItem.hour_err = MSG_REQUIRED; }
                if(parseFloat(rowItem.charge_rate_total)<=0 || rowItem.charge_rate_total.trim()==='') { foundIssue = 1; rowItem.charge_rate_total_err = MSG_REQUIRED; }
                numSkillRows++; 
            }
            else if(rowItem.rowActive==='yes' && rowItem.rowType==='exp') { 
                if(parseInt(rowItem.expId,10)===0) { foundIssue = 1; rowItem.expId_err = MSG_REQUIRED; }
                if(!checkNumDotZero(rowItem.cost) || parseFloat(rowItem.cost)<=0) { foundIssue = 1; rowItem.cost_err = MSG_REQUIRED; }
            }
        })   
        
        // if(!checkNum(this.state.numCrewChiefs) || this.state.numCrewChiefs==='') { 
        //     foundIssue = 1; 
        //     this.setState({numCrewChiefsErr:MSG_REQUIRED}); 
        // } 
        if(numSkillRows===0) return 4; 
        else if(foundCountIssue===3) return 3; 
        else if(foundIssue > 0) return 1; 
        else if(foundIssue===0) return 0; 
    } 

    saveData = (e) =>{
        let vResp = this.validateQuickAdd(); 
        if(Number(vResp)===0){ 
            let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
            let shift_skills = []; 
            let expenses = []; 
            shiftSkillOthExpEditDataRows.forEach(rowItem => {
                if(rowItem.rowActive==='yes' && rowItem.rowType==='skill') {
                    shift_skills.push({"count":rowItem.count, "chiefs_required":rowItem.chiefs_required, "hour":rowItem.hour, "base_pay_rate":rowItem.base_pay_rate, "charge_rate":rowItem.charge_rate, "skill":rowItem.skillId}); 
                }
                else if(rowItem.rowActive==='yes' && rowItem.rowType==='exp') {
                    expenses.push({"other_expense":rowItem.expId, "cost":rowItem.cost});
                }
            }) 
            let saveDataObj = {shift_skills:shift_skills, expenses:expenses, id:this.props.quoteShiftId, quick_update:true, department:this.state.department, apply_dept_all:this.state.applyDeptShifts};   // , no_of_chiefs: parseInt(this.state.numCrewChiefs,10)
            this.props.quoteQuickUpdateAction(saveDataObj); 
        }
        else {
            let errMsg = MSG_COMMON_FORM_ERROR;
            if(Number(vResp)===3) errMsg = msgChiefCountLess;  
            else if(Number(vResp)===4) errMsg = MSG_SKILL_ZERO_ERROR;  
            this.setState({errMsgCommon:errMsg}); 
            return false; 
        }

    }

    updateUsedRow = (dataType,currValue,newValue,rowNum) => {
        let tmpObj = {};  
        if(dataType==='removeRow') { 
            let skillRatesAllData = this.state.skillRatesAllData;
            tmpObj = skillRatesAllData.map(skillItem => parseInt(skillItem.usedRowNum,10)===parseInt(rowNum,10) ? {...skillItem, usedRowNum:0} :  skillItem ); 
            skillRatesAllData = tmpObj; 

            let otherExpensesMasterList = this.state.otherExpensesMasterList; 
            tmpObj = otherExpensesMasterList.map(expItem => parseInt(expItem.usedRowNum,10)===parseInt(rowNum,10) ? {...expItem, usedRowNum:0} : expItem ); 
            otherExpensesMasterList = tmpObj; 
            this.setState({skillRatesAllData,otherExpensesMasterList}); 
        }
        else if(dataType==='skill') {
            let skillRatesAllData = this.state.skillRatesAllData;
            tmpObj = skillRatesAllData.map(skillItem => parseInt(skillItem.skill_id,10)===parseInt(newValue,10) ? {...skillItem, usedRowNum:rowNum} : (parseInt(skillItem.skill_id,10)===parseInt(currValue,10) ? {...skillItem, usedRowNum:0} : skillItem) ); 
            skillRatesAllData = tmpObj; 
            this.setState({skillRatesAllData}); 
        }
        else if(dataType==='exp') {
            let otherExpensesMasterList = this.state.otherExpensesMasterList; 
            tmpObj = otherExpensesMasterList.map(expItem =>  parseInt(expItem.id,10)=== parseInt(currValue,10) ? {...expItem, usedRowNum:0} : ( parseInt(expItem.id,10)=== parseInt(newValue,10) ? {...expItem, usedRowNum:rowNum} : expItem) ); 
            otherExpensesMasterList = tmpObj; 
            this.setState({otherExpensesMasterList}); 
        }
    } 

    updateUsedSkillOExp = (dataType) => {
        if(dataType==='skill' || dataType==='both') {
            // {rowNum:totalDataRows, rowType:'skill', rowActive:'yes', shiftSkillId:0, skillId:0})
            // {rowNum:totalDataRows, rowType:'exp', rowActive:'yes', shiftExpId:0, expId:0, });
            let shiftSkillOthExpEditDataRows = this.state.shiftSkillOthExpEditDataRows; 
            let skillRatesAllData = this.state.skillRatesAllData; 
            let otherExpensesMasterList = this.state.otherExpensesMasterList; 
            let tmpObj = {}; 
            shiftSkillOthExpEditDataRows.forEach(rowItem => {
                if(rowItem.rowActive==='yes' && rowItem.rowType==='skill' && rowItem.skillId > 0) {
                    tmpObj = skillRatesAllData.map(skillItem => parseInt(skillItem.skill_id,10)===parseInt(rowItem.skillId,10) ? {...skillItem, usedRowNum:rowItem.rowNum} : skillItem); 
                    skillRatesAllData = tmpObj; 
                }
                else if(rowItem.rowActive==='yes' && rowItem.rowType==='exp' && rowItem.expId > 0) {
                    tmpObj = otherExpensesMasterList.map(expItem => parseInt(expItem.id,10)===parseInt(rowItem.expId,10) ? {...expItem, usedRowNum:rowItem.rowNum} : expItem); 
                    otherExpensesMasterList = tmpObj; 
                }
            });
            // this.setState({skillRatesAllData,otherExpensesMasterList}, () => {
            //     let numCrewChiefs = this.calcNumCrewChiefs(); 
            //     this.setState({numCrewChiefs:numCrewChiefs});  
            // }); 
            this.setState({skillRatesAllData,otherExpensesMasterList}); 
        }
    }

    callToaster = (isEnabled,message,isSucces)=>{
        this.props.callToaster(isEnabled,message,isSucces);
    }

    componentDidUpdate(prevProps) {
        const {subactivity,otherExps,rateCardStatus,rateCardsActivity,shiftQuickUpdateStatus, shiftQuickUpdateActivity,shiftDataDetails,shiftDataActivity,shiftQuickUpdateDetails,shiftQuickUpdateErrorData} = this.props;  // shiftIndividualDetails errorData, status, skillList, shiftIndividualActivity, shiftIndividualStatus, quoteShiftId, quoteShiftName
        if (subactivity && subactivity !== prevProps.subactivity) {
            let arrResp = subactivity.split('~~'); 
            let actString = arrResp[0]; 

            if(actString===OTHER_EXP_LIST_SUCCESS){
                let tmpArr = otherExps.map(item => ({...item, usedRowNum:0}) );
                this.setState({ otherExpensesMasterList: tmpArr })
            }
        }

        if (shiftDataActivity && shiftDataActivity !== prevProps.shiftDataActivity) {
            let shiftSkillAllDetails = {}; 
            let shiftSkillOthExpEditDataRows = []; 
            let rowNum = 0;
            let totalAmount = 0; 
            let numCrewChiefs = 0; 
            let crew_chief_bonus = 0; 
            let arrResp = shiftDataActivity.split('~~'); 
            let actString = arrResp[0]; 
            let chargeRateTotal = 0; 
            let totalSkillRowsServer = 0; 
            if(actString===SHIFT_GET_DETAILS_SUCCESS) { 
                shiftSkillAllDetails = shiftDataDetails; 
                numCrewChiefs = shiftDataDetails.no_of_chiefs; 
                crew_chief_bonus = shiftDataDetails.crew_chief_bonus;
                if(Array.isArray(shiftDataDetails.shift_skills)) {
                    shiftDataDetails.shift_skills.forEach(dataItem => {
                        rowNum++;
                        totalSkillRowsServer++; 
                        chargeRateTotal = dataItem.charge_rate_total; 
                        if(Number(dataItem.chiefs_required) > 0) {
                            chargeRateTotal = (parseFloat(dataItem.charge_rate_total)+(parseFloat(crew_chief_bonus)*parseFloat(dataItem.chiefs_required)*parseFloat(dataItem.hour))).toFixed(2); 
                        }
                        let shiftLength = convertDecimalToHHMM(dataItem.hour); 
                        shiftSkillOthExpEditDataRows.push({rowNum:rowNum, rowType:'skill', rowActive:'yes', shiftSkillId:dataItem.id, skillId:dataItem.skill.id, skill_name:dataItem.skill.skill_name, skillScheduled:dataItem.scheduled, count:dataItem.count, chiefs_required:dataItem.chiefs_required, base_pay_rate:dataItem.base_pay_rate, charge_rate:dataItem.charge_rate, charge_rate_total:chargeRateTotal, hour:dataItem.hour, shiftLength:shiftLength, skillId_err:'', count_err:'', chiefs_required_err: '',  hour_err:'', charge_rate_total_err:''});
                        
                        totalAmount += parseFloat(chargeRateTotal); 
                        
                    });
                }
                if(Array.isArray(shiftDataDetails.expenses)) {
                    shiftDataDetails.expenses.forEach(dataItem => {
                        rowNum++; 
                        // shiftSkillOthExpEditDataRows.push({rowNum:rowNum, rowType:'exp', rowActive:'yes', shiftExpId:dataItem.id, expId:dataItem.other_expense.id, name:dataItem.other_expense.name, cost:dataItem.cost, expId_err:'', cost_err:''});
                        shiftSkillOthExpEditDataRows.push({rowNum:rowNum, rowType:'exp', rowActive:'yes', shiftExpId:dataItem.id, expId:dataItem.other_expense_detials.id, name:dataItem.other_expense_detials.name, cost:dataItem.cost, expId_err:'', cost_err:''});

                        //{"other_expense":654,"cost":"112.00","id":396,"other_expense_detials":{"id":654,"name":"Tools Purchase","is_active":true,"affiliate":158}},

                        totalAmount += parseFloat(dataItem.cost); 
                    }); 
                }
                let deptCheckDisable = true;
                if(shiftDataDetails.department != null && shiftDataDetails.department != '' && shiftDataDetails.department != undefined)
                    deptCheckDisable = false;

                this.setState({shiftSkillOthExpEditDataRows:shiftSkillOthExpEditDataRows, totalDataRows:rowNum, shiftSkillAllDetails:shiftSkillAllDetails,totalAmount:totalAmount.toFixed(2),isSaveBtnEnable:false,numCrewChiefs:numCrewChiefs,crew_chief_bonus:crew_chief_bonus,totalSkillRowsServer, department: shiftDataDetails.department, deptCheckDisable: deptCheckDisable}, () => {
                    this.updateUsedSkillOExp('both');
                }); 
            } 
            else if(actString===SHIFT_GET_DETAILS_ERROR) { 
                this.setState({shiftSkillOthExpEditDataRows:shiftSkillOthExpEditDataRows, totalDataRows:rowNum, shiftSkillAllDetails:shiftSkillAllDetails,totalAmount:totalAmount.toFixed(2),numCrewChiefs:numCrewChiefs,crew_chief_bonus:crew_chief_bonus,totalSkillRowsServer});
            }
        }

        if (rateCardsActivity && (rateCardsActivity !== prevProps.rateCardsActivity || rateCardStatus !== prevProps.rateCardStatus)) { 
          
            var arrResp = rateCardsActivity.split('~~'); 
            var actString = arrResp[0]; 
            if(actString===SKILL_LIST_AFFILIATE_SUCCESS){  
                console.log('this.props.skillRatesAllData: ',JSON.stringify(this.props.skillRatesAllData)); 
                if(this.props.hasOwnProperty('skillRatesAllData')) {
                    if(this.props.skillRatesAllData.length===0) {
                        this.setState({skillRatesAllData: []}); 
                    }
                    else {
                        // activeSkillRateData: { skill_id: 0, skill_name: '', rates_data: [] },  
                        let allSkillsObj = []; 
                        let newObj = {}; 
                        this.props.skillRatesAllData.forEach((rObj) => { 
                            if(!Array.isArray(rObj.rates_data))  rObj.rates_data = []; 
                            
                            if(rObj.rates_data && rObj.rates_data.length===0) {
                                newObj = {...rObj, skill_id:rObj.id, usedRowNum:0, optDisabled:true}; 
                            }
                            else if(rObj.rates_data) {  
                                newObj = {...rObj, skill_id:rObj.id, usedRowNum:0, optDisabled:false}; 
                            }   
                            allSkillsObj.push(newObj);
                        });
                        this.setState({skillRatesAllData: allSkillsObj}); 
                    }
                } 
                else { 
                    this.setState({skillRatesAllData: []});                     
                    this.callToaster(true,LBL_SKILL+' Rates - '+MSG_SERVER_DATA_FETCH_ERROR,false);
                }
            }  
            else if(actString===SKILL_LIST_AFFILIATE_ERROR) { 
                this.setState({skillRatesAllData: []}); 
                this.callToaster(true,LBL_SKILL+' Rates - '+MSG_SERVER_DATA_FETCH_ERROR,false);
            }
        }

        if (shiftQuickUpdateActivity && (shiftQuickUpdateActivity !== prevProps.shiftQuickUpdateActivity || shiftQuickUpdateStatus !== prevProps.shiftQuickUpdateStatus)) {
            let arrResp = shiftQuickUpdateActivity.split('~~'); 
            let actString = arrResp[0]; 
            if(actString===SHIFT_QUICK_UPDATE_SUCCESS){  
                if(!shiftQuickUpdateDetails.hasOwnProperty('skills_cannot_remove') && !shiftQuickUpdateDetails.hasOwnProperty('skills_cannot_edit') && shiftQuickUpdateStatus===200) { 
                    this.reloadQuoteDetails(); 
                    this.props.reloadEventList();
                    this.callToaster(true,MSG_SHIFT_QUICK_UPDATE_SUCCESS,true);
                    this.props.closeEditQuoteModal();
                   
                    // setTimeout(()=> {
                    //    this.props.closeEditQuoteModal();
                    //    // this.props.reloadQuoteDetails(); 
                    // }, 500);
                    // CALL PARENT REFRESH 
                 }
                 else {
                    //let errorMsg = '';  
                    // if(this.props.hasOwnProperty('shiftQuickUpdateErrorData') && (this.props.shiftQuickUpdateErrorData)) {
                    //    errorMsg = (this.props.shiftQuickUpdateErrorData.hasOwnProperty('message')) ? ' - '+this.props.shiftQuickUpdateErrorData.message : ''; 
                    // } // DO NOT DISPLAY SERVER ERROR STRING 
                    this.callToaster(true,MSG_SHIFT_QUICK_UPDATE_ERROR,false);

                 } 
            }
            else if(actString===SHIFT_QUICK_UPDATE_ERROR){  
                // shiftQuickUpdateStatus===405 && 
                if(shiftQuickUpdateErrorData && shiftQuickUpdateErrorData.skills_cannot_remove && Array.isArray(shiftQuickUpdateErrorData.skills_cannot_remove)) {
                    let skillNames = '';
                    let sepVar = ''; 
                    if(shiftQuickUpdateErrorData.skills_cannot_remove.length > 0) {
                        shiftQuickUpdateErrorData.skills_cannot_remove.forEach(skillId => {
                            skillNames += sepVar+skillId.skill_name;
                            sepVar = ', ';
                        })
                    }
                    let msgStr = MSG_SHIFT_SKILL_REMOVE_ERROR+skillNames; 
                    this.callToaster(true,msgStr,false);
                    let {eventDataForShift} = this.props;
                    // this.reloadQuoteDetails(); 
                    // this.props.reloadEventList();                       
                    this.props.eventGetCrewChiefCountAction(eventDataForShift.affiliateId); 
                    if(Number(this.props.userGroup)!==Number(LOGIN_CLIENT_GROUP)) this.props.otherExpListAction({page:0,column:'name',shiftId:this.props.quoteShiftId});
                    if(Number(this.props.userGroup)!==Number(LOGIN_CLIENT_GROUP)) this.props.aflt_departmentsListAction({page:0,column:'name',shiftId:this.props.quoteShiftId,associated:'1'}); 
                    let tmpObj = {affId:eventDataForShift.affiliateId, clientId:eventDataForShift.clientId,departmentId:this.state.department,pageSize:0,page:0,column:'skill_name'} 
                    this.props.aflt_skillListAction(tmpObj); 
                    this.props.shiftGetDetailsAction(this.props.quoteShiftId);
                    // this.props.shiftIndividualDetailsAction(this.props.quoteShiftId); 
                   
                } // shiftQuickUpdateStatus===405 && 
                else if(shiftQuickUpdateErrorData && shiftQuickUpdateErrorData.skills_cannot_edit && Array.isArray(shiftQuickUpdateErrorData.skills_cannot_edit)) { 
                    let skillNames = '';
                    let sepVar = ''; 
                    if(shiftQuickUpdateErrorData.skills_cannot_edit.length > 0) {
                        shiftQuickUpdateErrorData.skills_cannot_edit.forEach(skillId => {
                                skillNames += sepVar+skillId.skill_name;
                                sepVar = ', ';
                        })
                    }
                    let msgStr = MSG_SHIFT_SKILL_EDIT_ERROR.replace(',', ' '+skillNames+', '); 
                    this.callToaster(true,msgStr,false);
                    // this.reloadQuoteDetails(); 
                    // this.props.reloadEventList();
                    let {eventDataForShift} = this.props;
                    this.props.eventGetCrewChiefCountAction(eventDataForShift.affiliateId); 
                    if(Number(this.props.userGroup)!==Number(LOGIN_CLIENT_GROUP)) this.props.otherExpListAction({page:0,column:'name',shiftId:this.props.quoteShiftId});    
                    if(Number(this.props.userGroup)!==Number(LOGIN_CLIENT_GROUP)) this.props.aflt_departmentsListAction({page:0,column:'name',shiftId:this.props.quoteShiftId,associated:'1'});
                    let tmpObj = {affId:eventDataForShift.affiliateId, clientId:eventDataForShift.clientId,departmentId:this.state.department,pageSize:0,page:0,column:'skill_name'} 
                    this.props.aflt_skillListAction(tmpObj); 
                    // this.props.shiftIndividualDetailsAction(this.props.quoteShiftId); 
                    this.props.shiftGetDetailsAction(this.props.quoteShiftId); 
                    
                }
                else {
                    //let errorMsg = '';  
                    // if(this.props.hasOwnProperty('shiftQuickUpdateErrorData') && (this.props.shiftQuickUpdateErrorData)) {
                    //    errorMsg = (this.props.shiftQuickUpdateErrorData.hasOwnProperty('message')) ? ' - '+this.props.shiftQuickUpdateErrorData.message : ''; 
                    // } // DO NOT DISPLAY SERVER ERROR STRING 
                    this.callToaster(true,MSG_SHIFT_QUICK_UPDATE_ERROR,false);
                 } 
            }
            else {
                if(this.props.hasOwnProperty('shiftQuickUpdateErrorData') && (this.props.shiftQuickUpdateErrorData)) {
                    // errorMsg = (this.props.shiftQuickUpdateErrorData.hasOwnProperty('message')) ? ' - '+this.props.shiftQuickUpdateErrorData.message : ''; 
                } 
                this.callToaster(true,MSG_SHIFT_QUICK_UPDATE_ERROR,false);
            }
        }
    }

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            this.setState({isClientPage:false, clientId:0});     
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            this.setState({isClientPage:true, clientId:userGroupData.profile_id});  
        }
        let {eventDataForShift} = this.props;
        this.props.eventGetCrewChiefCountAction(eventDataForShift.affiliateId); 
        if(Number(this.props.userGroup)!==Number(LOGIN_CLIENT_GROUP)) this.props.otherExpListAction({page:0,column:'name',shiftId:this.props.quoteShiftId});
        if(Number(this.props.userGroup)!==Number(LOGIN_CLIENT_GROUP)) this.props.aflt_departmentsListAction({page:0,column:'name',shiftId:this.props.quoteShiftId,associated:'1'});
        // this.props.shiftIndividualDetailsAction(this.props.quoteShiftId); 
        let tmpObj = {affId:eventDataForShift.affiliateId, clientId:eventDataForShift.clientId,departmentId:this.props.activeShiftDepartmentId,pageSize:0,page:0,column:'skill_name'} 
        this.props.aflt_skillListAction(tmpObj); 
        this.props.shiftGetDetailsAction(this.props.quoteShiftId); 
    }
    
    render(){
        const {profileCurrency,departments} = this.props;
        const {shiftSkillOthExpEditDataRows,totalDataRows,otherExpensesMasterList,totalAmount,skillRatesAllData,isSaveBtnEnable} = this.state;
        let tmpObj = skillRatesAllData.filter(item => (item.usedRowNum === 0 && !item.optDisabled)); 
        let unUsedSkills = tmpObj.length; 
        tmpObj = shiftSkillOthExpEditDataRows.filter(item => (item.rowType==='skill'));
        let skillsDataRows = tmpObj.length; 
        let totalSkills    = skillRatesAllData.length;  
        tmpObj = otherExpensesMasterList.filter(item => item.usedRowNum === 0); 
        let unUsedOExp = tmpObj.length; 
        let totalOExpenses = otherExpensesMasterList.length; 
        tmpObj = shiftSkillOthExpEditDataRows.filter(item => (item.rowType==='exp'));
        let oExpDataRows = tmpObj.length; 
        let activeSkillRows = 0;

        let userGroupData = userGroupUrlCheck(window.location); 
        let supervisor_name = ''; 

        if(userGroupData!==undefined){
           supervisor_name = userGroupData.supervisor_name
           msgChiefCountLess = stringFormat(MSG_CHIEF_COUNT_LESS,userGroupData.supervisor_name);
        }
        if(!supervisor_name){
            supervisor_name = LBL_CHIEFS;
            msgChiefCountLess = stringFormat(MSG_CHIEF_COUNT_LESS,'Chief');
        }


        return(
            <React.Fragment>                    
                    <div className="float-right">
                        {(unUsedSkills > 0 && totalSkills > skillsDataRows) && <button type="button" className="btn btn-primary" onClick={(e) => this.insertNewRow('skill')}>{LBL_ADD+' '+LBL_SKILL}</button>}
                        {(unUsedSkills===0 || totalSkills <= skillsDataRows) && <button type="button" className="btn disabledElement" disabled>{'Add '+LBL_SKILL}</button>}

                        {(Number(this.props.userGroup)!==Number(LOGIN_CLIENT_GROUP) && unUsedOExp > 0 && totalOExpenses > oExpDataRows) && <button type="button" className="btn btn-primary" onClick={(e) => this.insertNewRow('exp')}>{LBL_ADD+' '+LBL_OTHER_EXPENSES}</button>}
                        {((Number(this.props.userGroup)!==Number(LOGIN_CLIENT_GROUP)) && (unUsedOExp===0 || totalOExpenses <= oExpDataRows)) && <button type="button" className="btn disabledElement " disabled >{'Add '+LBL_OTHER_EXPENSES}</button>}
                    </div>

                    <table className="table">
                        <thead>
                            <tr>
                            <th scope="col">{LBL_SKILL}</th>
                            <th scope="col">&nbsp;&nbsp;Qty &nbsp;&nbsp;</th>
                            <th scope="col"> {supervisor_name}</th>
                            <th scope="col">&nbsp;&nbsp;&nbsp;{LBL_HOURS}&nbsp;&nbsp;&nbsp;</th>
                            <th scope="col">{LBL_CHARGE_RATE} ({profileCurrency})</th>
                            <th scope="col">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                        {shiftSkillOthExpEditDataRows && shiftSkillOthExpEditDataRows.map(rowItem => {
                            // rowNum:1,rowType:'skill/exp',rowActive:'yes',rowdataObj:[]
                            if(rowItem.rowActive==='yes' && rowItem.rowType==='skill') {
                                activeSkillRows++; 
                                return(
                                    <tr key={rowItem.rowNum}>
                                        <td className="form-group"> 
                                            
                                            {/* <div>{'rowItem: '+JSON.stringify(rowItem.skillId)}</div>
                                            <div>{'skillRatesAllData: '+JSON.stringify(skillRatesAllData.length)}</div> */}

                                            <div className="form-group select-input">
                                            <select name={"sel_skill_"+rowItem.rowNum} onChange={(e) => this.onHandleChange(rowItem.rowNum,'sel_skill',rowItem.skillId,e)} className={rowItem.skillId_err.length > 0 ? "input-error" : ''} value={rowItem.skillId}>
                                                <option value="0">Select</option>
                                                {skillRatesAllData.map((item) => (item.usedRowNum===0 || item.usedRowNum===rowItem.rowNum) ? ((item.optDisabled) ? 
                                                <option key={item.skill_id} value={item.skill_id} disabled >{item.skill_name}</option> : 
                                                <option key={item.skill_id} value={item.skill_id} >{item.skill_name}</option>) : '')} 
                                            </select> 
                                            </div>
                                        </td> 
                                        <td className="form-group"><div className="form-group text-input">
                                            <input type="text" name={"txt_qty_"+rowItem.rowNum} onChange={(e) => this.onHandleChange(rowItem.rowNum,'txt_qty',rowItem.count,e)} className={rowItem.count_err.length > 0 ? "input-error" : ''} value={rowItem.count} />
                                        </div></td>
                                        <td className="form-group"><div className="form-group text-input">
                                            <input type="text" name={"txt_qty_chiefs_"+rowItem.rowNum} onChange={(e) => this.onHandleChange(rowItem.rowNum,'txt_qty_chiefs',rowItem.chiefs_required,e)} className={rowItem.chiefs_required_err.length > 0 ? "input-error" : ''} value={rowItem.chiefs_required} />
                                        </div></td>
                                        <td className="form-group"><div className="form-group text-input">
                                            <input type="text" name={"txt_hrs_"+rowItem.rowNum} onChange={(e) => this.onHandleChange(rowItem.rowNum,'txt_hrs',rowItem.hour,e)} className={rowItem.hour_err.length > 0 ? "disabledElement input-error" : 'disabledElement'} value={rowItem.shiftLength} readOnly />
                                        </div></td>
                                        <td className="form-group"><div className="form-group text-input">
                                            <input type="text" name={"txt_rate_"+rowItem.rowNum} onChange={(e) => this.onHandleChange(rowItem.rowNum,'txt_rate',rowItem.charge_rate_total,e)} className={rowItem.charge_rate_total_err.length > 0 ? "disabledElement input-error" : 'disabledElement'} value={rowItem.charge_rate_total} readOnly  />
                                        </div></td>
                                        <td className="form-group"><div className="form-group"><i className={DELETE_SYMBOL} title='Remove this Row' onClick={(e) => this.deleteBtnClick(rowItem.rowNum)} ></i></div></td>
                                    </tr>
                                )
                            }
                            else if(rowItem.rowActive==='yes' && rowItem.rowType==='exp') {
                                return(
                                    <tr key={rowItem.rowNum}>
                                        <td> 
                                            <div className="form-group select-input">
                                            {(Number(this.props.userGroup)===Number(LOGIN_CLIENT_GROUP)) && <select name={"sel_exp_"+rowItem.rowNum} onChange={(e) => this.onHandleChange(rowItem.rowNum,'sel_exp',rowItem.expId,e)} className={rowItem.expId_err.length > 0 ? "input-error" : ''} value={rowItem.expId} disabled > 
                                                <option value={rowItem.expId}>{rowItem.name}</option> 
                                            </select> }
                                            
                                            {(Number(this.props.userGroup)!==Number(LOGIN_CLIENT_GROUP)) && <select name={"sel_exp_"+rowItem.rowNum} onChange={(e) => this.onHandleChange(rowItem.rowNum,'sel_exp',rowItem.expId,e)} className={rowItem.expId_err.length > 0 ? "input-error" : ''} value={rowItem.expId} > 
                                                <option value="0">Select</option>
                                                {otherExpensesMasterList.map((item) =>  (item.usedRowNum===0 || item.usedRowNum===rowItem.rowNum) && <option key={item.id} value={item.id}>{item.name}</option>)} 
                                            </select> }
                                            </div>
                                        </td>
                                        <td className="form-group">&nbsp;</td>
                                        <td className="form-group">&nbsp;</td>
                                        <td className="form-group">&nbsp;</td>

                                        <td className="form-group"><div className="form-group text-input ">
                                        {(Number(this.props.userGroup)===Number(LOGIN_CLIENT_GROUP)) && <input type="text" name={"txt_exp_rate_"+rowItem.rowNum} onChange={(e) => this.onHandleChange(rowItem.rowNum,'txt_exp_rate',rowItem.cost,e)} className={rowItem.cost_err.length > 0 ? "disabledElement input-error" : ' disabledElement'} value={rowItem.cost} disabled />}
                                        {(Number(this.props.userGroup)!==Number(LOGIN_CLIENT_GROUP)) && <input type="text" name={"txt_exp_rate_"+rowItem.rowNum} onChange={(e) => this.onHandleChange(rowItem.rowNum,'txt_exp_rate',rowItem.cost,e)} className={rowItem.cost_err.length > 0 ? "input-error" : ''} value={rowItem.cost} />}
                                        </div></td>
                                        <td className="form-group"><div className="form-group"><i className={DELETE_SYMBOL} title='Remove this Row' onClick={(e) => this.deleteBtnClick(rowItem.rowNum)} ></i></div></td>
                                    </tr>
                                )
                            }
                        })}
                        {(totalDataRows > 0) && 
                            <tr className="text-bold"> 
                                <td colSpan="3" className="left-align form-group text-input"> 
                                    {/* Number of {LBL_CREW_CHIEFS}: &nbsp;    
                                    <input type="text" name="txt_numCrewChiefs" onChange={(e) => this.onHandleChangeTot(e)} value={this.state.numCrewChiefs} className={this.state.numCrewChiefsErr.length > 0 ? "inputNum50 input-error" : 'inputNum50'} /> */}
                                </td>
                                <td className="right-align"> Total</td>
                                <td className="form-group">&nbsp;&nbsp;&nbsp;{totalAmount}</td>
                                <td className="form-group">&nbsp;</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                    <div className={!this.state.isClientPage?"row":"row hide"}>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_DEPARTMENT}</label>  
                                <div className={'form-group select-input'}>
                                    <select onChange={this.onHandleDeptChange} name="department" value={this.state.department} disabled >
                                        <option value="" data-loc="">{LBL_SELECT}</option>
                                        {departments.map((item) => <option key={item.id} value={item.id} data-loc={item.key_location}>{item.name}</option>)}
                                    </select>                                
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                {/* <label>&nbsp;</label>
                                <div className="form-group custom-checkbox">
                                    <input type="checkbox" id="applyDeptShifts" disabled={this.state.deptCheckDisable} name="applyDeptShifts" onChange={this.onHandleDeptChange} checked={this.state.applyDeptShifts} /><label className="checkbox" htmlFor="applyDeptShifts"></label><label className="labeltext" htmlFor="applyDeptShifts">{LBL_DEPARTMENT_ALL_SHIFTS}</label>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className="float-right"> 
                        <div className="text-red"><div className="float-right"><small>{this.state.errMsgCommon}</small></div></div>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.props.closeEditQuoteModal}>Cancel</button> 
                        { (this.state.totalSkillRowsServer > 0 || activeSkillRows > 0) && <button type="button" className="btn btn-primary float-right" onClick={this.saveData} disabled={!isSaveBtnEnable} > &nbsp; &nbsp; Update Quote &nbsp; &nbsp; </button>} 
                        { this.state.totalSkillRowsServer===0 && activeSkillRows===0 && <button type="button" className="btn float-right disabledElement" readOnly disabled={!isSaveBtnEnable}> &nbsp; &nbsp; Update Quote &nbsp; &nbsp; </button>}
                    </div>
                    <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}> Are you sure you want to delete this {this.state.deleteRowName}? </ModalWindow>
            </React.Fragment>      
        )
    }
}

const mapStateToProps = (state) => { 
    // console.log('rateCardsActivity:'+state.afltSkills.activity); 
    // console.log('skillRatesAllData:'+JSON.stringify(state.afltSkills.items)); 
    return {
        otherExps : state.event.otherExps,
        subactivity:state.event.subactivity,        
        errorData:state.event.errorData,
        shiftQuickUpdateDetails:state.event.shiftQuickUpdateDetails,
        shiftQuickUpdateStatus: state.event.shiftQuickUpdateStatus,
        shiftQuickUpdateActivity: state.event.shiftQuickUpdateActivity,
        shiftQuickUpdateErrorData: state.event.shiftQuickUpdateErrorData,
        crewChiefCount:state.event.crewChiefCount,
        shiftDataDetails:state.event.shiftDataDetails,           
        shiftDataStatus: state.event.shiftDataStatus,
        shiftDataActivity: state.event.shiftDataActivity,
        departments: state.afltDepartments.departmentsList,
        // skillRatesAllData:state.clientRateCard.skillRateAllItems.data,
        // rateCardStatus:state.clientRateCard.status,
        // rateCardsActivity:state.clientRateCard.activity, 
        skillRatesAllData : state.afltSkills.items, 
        rateCardStatus:state.afltSkills.status,
        rateCardsActivity:state.afltSkills.activity,
    }
};
 
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        otherExpListAction: otherExpListAction, 
        aflt_skillListAction: aflt_skillListAction,
        quoteQuickUpdateAction:quoteQuickUpdateAction,
        eventGetCrewChiefCountAction:eventGetCrewChiefCountAction,
        shiftGetDetailsAction:shiftGetDetailsAction,
        aflt_departmentsListAction:aflt_departmentsListAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(ShiftSkillsQuickEdit);
